module.exports = __webpack_public_path__ + "img/cicle_cha.61960f01.png";